export const APPLICATION_FORM_ROUTES = '/dokumente*';
export const APPLICATION_FORM_BASE_ROUTE = '/dokumente';
export const DETAILS_BASE_ROUTE = '/details';
export const DETAILS_ROUTE = `${APPLICATION_FORM_BASE_ROUTE}${DETAILS_BASE_ROUTE}/:applicationFormId`;
export const WIZARD_ROUTE = `${APPLICATION_FORM_BASE_ROUTE}/:wizard`;
export const PRE_SELECTION_ROUTE = `${APPLICATION_FORM_BASE_ROUTE}/auswahl`;
